import axios from "axios";
import qs from "qs";
import * as apiConstants from "../constants/api-constants";
import { siteUrl } from "../utils/siteUrl";
// import SessionService from "./session";
// import useBrowserMode from "../hooks/useBrowserMode";

export const axiosInstance = axios.create();
// var ipAddress = "";
// getIp();

// //Get ip Address from jsonip
// const getIp = () => {
//   if (!sessionStorage.getItem("ipAddress")) {
//     var dataIp;
//     axios.get(apiConstants.GET_IP_ADDRESS).then(response => {
//       sessionStorage.setItem("ipAddress", response.data.ip)
//       dataIp = response.data.ip
//     }).catch(err => console.log(err))
//     return dataIp
//   } else {
//     return JSON.parse(sessionStorage.getItem("ipAddress"))
//   }
// }
// handle request configs
// axiosInstance.interceptors.request.use(
//   (config) => {
//     config.headers['Ip-Address'] = getIp();
//     return config;
//   },
//   error => {
//     Promise.reject(error)
//   }
// );

const holderVariables = {}
async function getIp() {
  if (holderVariables.ip) {
    return holderVariables.ip
  }
  if (sessionStorage.getItem("ipAddress")) {
    holderVariables.ip = sessionStorage.getItem("ipAddress")
    return holderVariables.ip
  }
  holderVariables.ip = new Promise((resolve, reject) => {
    axios
      .get(apiConstants.GET_IP_ADDRESS, { timeout: 5000 })
      .then(response => {
        resolve(response.data.ip)
      })
      .catch(error => {
        resolve('127.0.0.1')
      })
  })
  return holderVariables.ip
}

axiosInstance.interceptors.request.use(
  async config => {
    let ip = await getIp()
    sessionStorage.setItem('ipAddress', ip)
    config.headers['Ip-Address'] = ip
    return config
  },
  error => {
    return Promise.reject(error)
  }
);

// handle response error general case
axiosInstance.interceptors.response.use(response => response,
  error => {
    const originalRequest = error.config;
    // Error
    const { response: { status } } = error;

    if (status === 401) {
      // Unauthorized request: maybe access token has expired!
      return refreshAccessToken(originalRequest);
    } else {
      return Promise.reject(error);
    }
  }
);

const refreshAccessToken = (_originalRequest) => {
  _originalRequest._retry = true;

  const payload = qs.stringify({
    grant_type: "refresh_token",
    client_id: apiConstants.CLIENT_ID,
    refresh_token: JSON.parse(localStorage.getItem("TOKEN_INFO")).refreshToken
  });

  return axiosInstance.post(apiConstants.REFRESH_TOKEN, payload, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
  }).then(response => {
    if (response.status === 200) {

      //Find and replace token data
      const _currentTokenData = JSON.parse(localStorage.getItem("TOKEN_INFO"));
      _currentTokenData["accessToken"] = response.data.access_token;
      _currentTokenData["idToken"] = response.data.id_token;

      //Set new token data
      localStorage.setItem("TOKEN_INFO", JSON.stringify(_currentTokenData));

      // Replace token in original request
      _originalRequest.headers.Authorization = response.data.id_token

      return axios(_originalRequest);
    } else {
      localStorage.removeItem('USER_INFO')
      localStorage.removeItem('TOKEN_INFO')
      window.location.href = siteUrl + '/'
    }
  }).catch(err => {
    console.log(err)
    localStorage.removeItem('USER_INFO')
    localStorage.removeItem('TOKEN_INFO')
    window.location.href = siteUrl + '/'
  });
};